if (!customElements.get('business-card-print-context')) {
  customElements.define('business-card-print-context', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const selection = this.querySelector('[data-print-selection]');
      const quantity = this.querySelector('[data-print-quantity]');
      const variantField = this.querySelector('[data-print-variant]');
      const urlField = this.querySelector('[data-print-url]');
      const params = new URL(location.href).searchParams;
      const form = this.closest('form');
      const storageKey = 'zippopiu-business-card-quote';
      let saved;
      try {
        if (form.querySelector('.zcl-errors')) saved = JSON.parse(sessionStorage.getItem(storageKey));
        if (form.querySelector('.zcl-success')) sessionStorage.removeItem(storageKey);
      } catch {}
      const option = [...selection.options].find(item => item.dataset.variantId === (saved?.variant ?? params.get('print_variant')));
      if (option) {
        selection.value = option.value;
        const count = Number(saved?.quantity || params.get('print_quantity') || 1);
        if (Number.isSafeInteger(count) && count > 0) quantity.value = String(count);
      }
      const update = () => {
        const variant = selection.selectedOptions[0]?.dataset.variantId;
        this.querySelector('[data-print-quantity-label]').hidden = !variant;
        this.querySelector('[data-print-note]').hidden = !variant;
        for (const field of [quantity, variantField, urlField]) field.disabled = !variant;
        variantField.value = variant || '';
        urlField.value = variant ? `${this.dataset.productUrl}?variant=${variant}` : '';
      };
      selection.addEventListener('change', update, { signal: this.controller.signal });
      form.addEventListener('submit', () => {
        update();
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({ variant: variantField.value, quantity: quantity.value }));
        } catch {}
      }, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
